import React from 'react'
import Modal from '../../../../../components/structure/Modal'
import FlexGrid, { FlexCol } from '../../../../../components/structure/FlexGrid'
import { HorizontalLine, VerticalLine } from '../../../../../components/shapes/Line'
import { SmallText } from '../../../../../components/presentation/Text'
import Separator from '../../../../../components/helpers/Separator'
import EventsList from './EventsList'
import { COLORS } from '@btime/constants'
import BasicInfo from './BasicInfo'

const ShowServiceOrderHistoryDetailsModal = ({ isShowing, serviceOrder, ...props }) => {
  return (
    <Modal open={isShowing} width="62rem" {...props}>
      <FlexGrid justify="space-between" align="flex-start" paddingGutter={0.5} wrap>
        <FlexCol flex={2} wrapOn="sm">
          <BasicInfo serviceOrder={serviceOrder} />
        </FlexCol>

        <FlexCol alignSelf="stretch" hideOn="sm">
          <VerticalLine thin lineColor={COLORS.light2} fullHeight />
        </FlexCol>

        <FlexCol alignSelf="stretch" hideOn="mdu" wrapOn="sm">
          <HorizontalLine thin lineColor={COLORS.light2} />
        </FlexCol>

        <FlexCol flex={1}>
          <SmallText bold>Histórico</SmallText>
          <Separator />
          <EventsList serviceOrder={serviceOrder} />
        </FlexCol>
      </FlexGrid>
    </Modal>
  )
}

export default ShowServiceOrderHistoryDetailsModal
